<template lang="pug">
span( :class="getTextColor(getText)") {{ getText }}
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'columnStatusExportTemplate'
})
export default class StatusExportTemplateComponent extends Vue {
  data: any

  get getText() {
    const { field } = this.data.column
    const value = this.data[field]
    if (value === '' || value === null || value === undefined || value === false) {
      return ''
    }
    if (value === true || value === '1' || value === 1) {
      return this.$t('action_buttons.exported')
    }
    if (value === false || value === '0' || value === 0) {
      return this.$t('action_buttons.not_exported')
    }
    return value
  }

  getTextColor(status: string): string {
    switch (status) {
      case this.$t('action_buttons.exported'):
        return 'light-grey status'
      case this.$t('action_buttons.not_exported'):
        return 'light-blue status'
      default:
        return ''
    }
  }
}
</script>
